//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const TABLE_LIST_COLUMNS = [
  {
    name: "role",
    align: "left",
    label: "Papel",
    field: (row) => row.name,
    sortable: false,
  },
  {
    name: "permissions",
    label: "Permissões",
    align: "left",
    field: (row) => row.permissions.toString().replaceAll(",", " / "),
    sortable: false,
  },
];

export default {
  name: "PermissionsManagementTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: () => {},
  data: () => ({
    separator: "horizontal",
    pagination: {
      rowsPerPage: 10, // current rows per page being displayed
    },
    columns: TABLE_LIST_COLUMNS,
  }),
  methods: {
    fetchRowData: function (event) {
      this.$emit("clicked-row", event);
    },
    renderRightSide: function (event) {
      this.fetchRowData(event);
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
  },
};
